import React, { Component } from "react";
import { connect } from "react-redux";
// import Drag from '../../campaign/dragNdDropKycFile';
import Drag from "./dragNdDrop";
import { putServerDataWithPath } from "../../../action/common_action";
import { domain, fileUrl, endPoints } from "../../../config";
import { EditorState, convertToRaw } from "draft-js";
import Editor from "draft-js-plugins-editor";
import createToolbarPlugin, { Separator } from "draft-js-static-toolbar-plugin";
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
  CodeBlockButton,
} from "draft-js-buttons";
import { stateFromHTML } from "draft-js-import-html";
import "draft-js-static-toolbar-plugin/lib/plugin.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import { axiosInstnace as axios } from "../../../util/util";

import { ANY_ERROR } from "../../../action/user_action_types";
const staticToolBarPlugin = createToolbarPlugin();
const ToolbarStatic = staticToolBarPlugin.Toolbar;

class HeadlinesPicker extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.addEventListener("click", this.onWindowClick);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.onWindowClick);
  }

  onWindowClick = () =>
    // Call `onOverrideContent` again with `undefined`
    // so the toolbar can show its regular content again.
    this.props.onOverrideContent(undefined);

  render() {
    const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton];
    return (
      <div>
        {buttons.map((
          Button,
          i // eslint-disable-next-line
        ) => (
          <Button key={i} {...this.props} />
        ))}
      </div>
    );
  }
}

class HeadlinesButton extends Component {
  onClick = () =>
    // A button can call `onOverrideContent` to replace the content
    // of the toolbar. This can be useful for displaying sub
    // menus or requesting additional information from the user.
    this.props.onOverrideContent(HeadlinesPicker);

  render() {
    return (
      <div className="headlineButtonWrapper">
        <button onClick={this.onClick} className="headlineButton">
          H
        </button>
      </div>
    );
  }
}

class AudioBriefPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audio_file: null,
      audio_duration: 0,
      editor: "",
      plugins: [staticToolBarPlugin],
      audioBrief: EditorState.createWithContent(
        stateFromHTML(props.campaignDetails.audioBrief)
      ),
      styles: {
        editor: {
          height: "300px",
          overflow: "auto",
          width:"100%",
          fontWeight:"normal"
        },
      },
      language: props.campaignDetails.language
    };
    debugger
    if (props.type == "update") {
      this.state.styles.editor["border"] = "1px solid gray";
    }
    if (
      !props.campaignDetails.audioBrief ||
      props.campaignDetails.audioBrief.trim() == ""
    ) {
      this.state.audioBrief = EditorState.createWithContent(
        stateFromHTML("Not Available")
      );
    }
    console.log(this.state.static);
  }

  //Upload a file
  getUploadedFile = (files) => {
    console.log(files);
    this.setState({ audio_file: files });
    this.getAudioDuration(files, this);
  };

  //Remove file
  removeFile = () => {
    console.log(this.props);
    this.setState({
      audio_file: null,
    });
  };

  setEditorState = (editor) => {
    this.setState({ editor });
    console.log(this.state.editor);
  };
  focusEditor = () => {
    if (this.state.editor) {
      this.state.editor.focus();
    }
  };

  getAudioDuration = (file, state) => {
    var reader = new FileReader();
    let audioDuration = 0;
    reader.onload = function () {
      var audio = new Audio(reader.result);
      audio.onloadedmetadata = async () => {
        audioDuration = Math.floor(audio.duration);
        state.state.audio_duration = parseInt(Math.floor(audio.duration));
      };

      console.log(audioDuration);
    };
    reader.readAsDataURL(file);
  };

  changeAudioBrief = async () => {
    let { campaignDetails } = this.props;
    if (!this.state.audioBrief.getCurrentContent().hasText()) {
      this.handleToastError("Enter AudioBrief and file to Proceed ");
      return;
    }

    if (!this.state.language) {
      this.handleToastError("Select language");
      return;
    }
    let convertedHTML = draftToHtml(
      convertToRaw(this.state.audioBrief.getCurrentContent())
    );
    debugger;
    let data = {
      _id: campaignDetails._id,
      updateObj: {
        audioBrief: convertedHTML, // uploadAudioBrief
        language: this.state.language
      },
    };
    // await this.props.updateCompainAudio(endPoints.updateCampaignAudio, formData, '/dashboard');
    const result = await axios.post(endPoints.updateCampaign, data);
    this.props.hideAudioBrief();
  };

  getAudioBrief = (e) => {
    this.setState({ audioBrief: e });
  };

  handleLanguage = (value) => {
    this.setState({ language: value });

    console.log(value, this.state);
    debugger;
  }

  uploadAudioFile = () => {
    let { audio_file } = this.state;
    let { campaignDetails } = this.props;
    let formData = new FormData();
    formData.append("file", audio_file);
    formData.append("fileName", audio_file.name);
    formData.append("fileSize", audio_file.size);
    formData.append("audioDuration", this.state.audio_duration);
    formData.append("_id", campaignDetails._id);
    this.props.updateAudioToCampaign(
      endPoints.updateCampaignAudio,
      formData,
      "/admin/audioRequestManagement"
    );
    alert("Audio Duration - " + this.state.audio_duration);
  };

  render() {
    let { audio_file } = this.state;
    let { campaignDetails, type } = this.props;
    return (
      <div>
        <div className="modal-overlay">
          <div
            className="modal-wrapper thankyou-popup"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div
              className="modal modal-brief"
              style={{ width: "100% !important" }}
            >
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={() => this.props.hideAudioBrief()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <h4 className="popup-head rqst-head fct-head modal-title">
                    Audio Brief
                  </h4>
                </div>
                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <form className="form-group">
                      <div className="popupCampaign-container">
                        <div className="campaign-input master-inputs nonFct">
                          <div className="lenght_file_wrapper">
                            <div className="flie_audio">
                              {type == "update" && (
                                <React.Fragment>
                                  <div
                                    style={this.state.styles.editor}
                                    onClick={this.focusEditor}
                                  >
                                    <Editor
                                      ref={this.setEditorState}
                                      editorState={this.state.audioBrief}
                                      onChange={this.getAudioBrief}
                                      plugins={this.state.plugins}
                                    />
                                  </div>{" "}
                                  <div>
                                    <ToolbarStatic>
                                      {
                                        // may be use React.Fragment instead of div to improve perfomance after React 16
                                        (externalProps) => (
                                          <div>
                                            <BoldButton {...externalProps} />
                                            <ItalicButton {...externalProps} />
                                            <UnderlineButton
                                              {...externalProps}
                                            />
                                            <CodeButton {...externalProps} />
                                            <Separator {...externalProps} />
                                            <HeadlinesButton
                                              {...externalProps}
                                            />
                                            <UnorderedListButton
                                              {...externalProps}
                                            />
                                            <OrderedListButton
                                              {...externalProps}
                                            />
                                            <BlockquoteButton
                                              {...externalProps}
                                            />
                                            <CodeBlockButton
                                              {...externalProps}
                                            />
                                          </div>
                                        )
                                      }
                                    </ToolbarStatic>
                                  </div>{" "}
                                  <div style={{marginTop: "15px", marginBottom: "15px"}}>
                                    <label for="language" style={{fontWeight: "500", fontSize: ".85em"}}>Select Language</label>
                                    <select className="packageType drop-down-icon status-dropdown" id="language" onChange={ (e) => { this.handleLanguage(e.target.value) } } value={this.state.language}>
                                      <option value=""></option>{" "}
                                      <option value="Assamese">Assamese</option>{" "}
                                      <option value="Bengali">Bengali</option>{" "}
                                      <option value="English">English</option>{" "}
                                      <option value="Gujarati">Gujarati</option>{" "}
                                      <option value="Hindi">Hindi</option>{" "}
                                      <option value="Kannada">Kannada</option>{" "}
                                      <option value="Khasi">Khasi</option>{" "}
                                      <option value="Konkani">Konkani</option>{" "}
                                      <option value="Malayalam">Malayalam</option>{" "}
                                      <option value="Marathi">Marathi</option>{" "}
                                      <option value="Oriya">Oriya</option>{" "}
                                      <option value="Punjabi">Punjabi</option>{" "}
                                      <option value="Tamil">Tamil</option>{" "}
                                      <option value="Telugu">Telugu</option>{" "}
                                      <option value="Tulu">Tulu</option>{" "}
                                    </select>
                                  </div>
                                </React.Fragment>
                              )}
                              {type == "view" && (
                                  <div
                                    style={this.state.styles.editor}
                                    onClick={this.focusEditor}
                                  >
                                    <Editor
                                      ref={this.setEditorState}
                                      editorState={this.state.audioBrief}
                                      readOnly="true"
                                    />
                                  </div>
                  
                              )}{" "}
                              {type == "update" &&
                                campaignDetails.bigFmAudio &&
                                campaignDetails.bigFmAudio === "true" &&
                                (campaignDetails.audioStatus === "Requested" ||
                                  campaignDetails.audioStatus ===
                                    "Audio Rejected") && (
                                  <div className="book_camp_btn">
                                    <button onClick={this.changeAudioBrief}>
                                      Submit Audio Brief
                                    </button>
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    updateAudioToCampaign: (url, data, path) =>
      dispatch(putServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(AudioBriefPopup);



// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/AudioBriefPopup.js